import { ReactElement } from 'react';
import { Rating } from '@mantine/core';
import { useProductReviewsQuery } from '../../../services/product/product.queries';
import styles from '../ProductDisplayPage.module.scss';

type Props = {
  productId: number;
  interactive?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
};

export function ProductRating({
  productId,
  interactive = true,
  size = 'lg',
  className,
}: Props): ReactElement {
  const { data } = useProductReviewsQuery(productId);
  const bottomline = data?.bottomline;
  const averageScore = bottomline?.average_score ?? 0;
  const totalReviews = bottomline?.total_review ?? 0;

  const scrollToReviews = () => {
    document.getElementById('customer-reviews')
      ?.scrollIntoView({ behavior: 'smooth' });
  };

  const inner = (
    <span>
      <Rating value={averageScore} fractions={2} size={size} readOnly />
      <span className={styles.product_review_count}>
        <div style={{ fontWeight: 700 }}>{averageScore.toFixed(1)}</div>
        (
        {totalReviews}
        {' '}
        {totalReviews === 1 ? 'review' : 'reviews'}
        )
      </span>
    </span>
  );

  if (interactive) {
    return (
      <div
        role="button"
        tabIndex={0}
        className={`${styles.product_rating}${className ? ` ${className}` : ''}`}
        onClick={scrollToReviews}
        onKeyDown={(e) => e.key === 'Enter' && scrollToReviews()}
      >
        {inner}
      </div>
    );
  }

  return (
    <div className={`${styles.product_rating}${className ? ` ${className}` : ''}`}>
      {inner}
    </div>
  );
}
